module.exports = __webpack_public_path__ + "img/42dfcb5.jpg";